/**
 * @param {ProductVariantCollection} productVariant
 * @return {number}
 */
const isAvailableRawProductVariantUtil = (productVariant) => {
  return (
    !!productVariant?.available ||
    !!productVariant?.isAvailable
  )
}

export default isAvailableRawProductVariantUtil
